import {
  IWorkflowItemStep,
  IKeywords,
  IInvolvedParty,
  PagedResultsRequest,
  IPageResultsResponse,
} from "../../../../common/sharedTypes";

export class KeywordInfo {
  constructor(
    //Crash
    public id: string,
    public reportType: string, //might not need
    public crashCityOrPlace: string,
    public timeOfRoadwayClearance: string,
    public property: string,
    public dmvExclusionCode: string,

    //Vehicle
    public vehicleNumber: string,
    public motorVehicleUnitType: string,
    public vehicleOwnerName: string,
    public licensePlateNumber: string,
    public state: string,
    public registrationYear: string,
    public vehicleMake: string,
    public vehicleModel: string,
    public vehicleModelYear: string,
    public plateType: string,
    public vehicleIdentificationNumber: string,
    public motorVehicleTypeCategory: string,
    public damageEstimate: string,
    public sequenceOfEvents: string,
    public withinInterchangeArea: boolean,
    public typeOfIntersection: string,
    public propertyObjectDamaged: string,

    //Driver / Occupant
    public driverName: string,
    public dateOfBirth: string,
    public driverLicenseNumber: string,
    public driverLicenseState: string,
    public driverInjury: string,

    //Occupant
    public occupantName: string,
    public occupantDateOfBirth: string,
    public occupantDriverLicenseNumber: string,
    public occupantDriverLicenseState: string,
    public occupantInjury: string,

    //Non-Motorist
    public nonMotoristNumber: string,
    public nonMotoristName: string,
    public nonMotoristDateOfBirth: string,

    //Commercial / Truck / Bus
    public commercialTruckBusVehicleNumber: string,
    public commercialTruckBusCarrierName: string,

    public county: string,
    public selectedReportType?: string
  ) {}
}

export class NDOTPaperReport {
  constructor(public crashKey: string, public pdf: string[]) {}
}
export class AgencyInfo {
  constructor(
    public id: number,
    public name: string,
    public description: string,
    public ori: string,
    public email: string,
    public vendor: string,
    public createdById: string,
    public createdDate: string,
    public modifiedById: string,
    public modifiedDate: string,
    public vendorId?: string
  ) {}
}

export class TypeInfo {
  constructor(
    public name: string,
    public description: string,
    public active: boolean,
    public version: number,
    public modifiedBy: number,
    public modifiedDate: Date,
    public id: number
  ) {}
}

export class NameInfo {
  constructor(public id: number, public firstName: string, public lastName: string) {}
}

export class CountyInfo {
  constructor(
    public id: number,
    public name: string,
    public description: string,
    public active: boolean,
    public version: number,
    public fips: string,
    public modified_by?: number,
    public modified_date?: string
  ) {}
}

export class ReportTypesInfo {
  constructor(
    public id: number,
    public name: string,
    public description: string,
    public active: boolean,
    public version: number,
    public fips: string,
    public modified_by?: number,
    public modified_date?: string
  ) {}
}

export class ErrorInfo {
  constructor(
    public crashDate: string,
    public countySelection: string,
    public injurySelection: string,
    public involvedPartyLength: string,
    public involvedPartyFirstName: string,
    public involvedPartyLastName: string
  ) {}
}

export const initialErrorState: ErrorInfo = {
  crashDate: "",
  countySelection: "",
  injurySelection: "",
  involvedPartyLength: "",
  involvedPartyFirstName: "",
  involvedPartyLastName: "",
};

export const initialInvolvedParty: IInvolvedParty = {
  id: 0,
  firstName: "",
  lastName: "",
  businessName: "",
  businessOwned: false,
};

export interface IPaperKeywordRequest {
  workflowItemStepId: number;
  assignNext: boolean;
  assignTo?: number;
  keywords?: IKeywords;
  matchedReportId?: number;
}

export class SearchKeywordQueuePagedRequest extends PagedResultsRequest {
  public assignedOnly: boolean;
  public userOnly: boolean;
  public startDate?: string;
  public endDate?: string;
  public workflowStatus?: number;
  public includeInactive: boolean;
  public includeNewDriverReports: boolean;
  public unassignedOnly: boolean;
}

export class KeywordQueueItem {
  id?: number;
  createdDate?: Date;
  documentId?: string;
  assignedToUserName?: string;
  assignedToUserId?: number;
  agencyName?: string;
  workflowStatus?: string;
  priority?: string;
  onBasePriorityNumber?: number;
  reportStatusId?: number;

  constructor(workflowItem: IWorkflowItemStep) {
    (this.id = workflowItem.id),
      (this.createdDate = workflowItem?.workflowItem?.report?.createdDate);
    this.documentId = workflowItem?.workflowItem?.report?.documentId;
    this.assignedToUserName = workflowItem?.user?.userName;
    this.agencyName = workflowItem?.workflowItem?.report?.keywords?.agency?.name;
    this.workflowStatus = workflowItem?.workflowStepStatus?.name;
    this.priority = workflowItem?.workflowItem?.report?.keywords?.priority;
    this.onBasePriorityNumber = workflowItem?.workflowItem?.report?.keywords?.onBasePriorityNumber;
    this.reportStatusId = workflowItem?.workflowItem?.report?.reportStatusId;
  }
}

export interface ISearchKeywordQueuePagedResponse extends IPageResultsResponse {
  queueItems?: KeywordQueueItem[];
}
